module.exports = __webpack_public_path__ + "static/media/x-icon-2.2497aea4.svg";